import React, { useState, useEffect } from 'react'
import Header from '../navigation/Header.js' 
import { useSelector, useDispatch } from 'react-redux'
import { fetchPresenterInvitation, selectPresenterInvitation, updatePresenterInvitation } from '../../features/events/presenterInvitationSlice'
import { useParams } from "react-router-dom";
import NumberFormat from 'react-number-format';
// import { openModal } from '../features/modals/modalSlice'
import Spinner from '../../components/Spinner'

const StartResponseButton = ({ clickHandler }) => {
	return(
		<div>
			<a href="#" className="button" onClick={clickHandler} style={{marginBottom: '0'}}>
				Respond to invitation
			</a>
			<br />
			<p style={{fontSize: '0.875rem'}}>(Tell us whether or not you can be the presenter)</p>
		</div>
	)	
}

const LabeledValue = ({ label, value }) => {
	return (
		<div style={{margin: '1rem 1rem 2rem'}}>
			<dt>{label}</dt>
			<dd>{value}</dd>
		</div>
	)	
}

const ResponseModal = ({ invitationId, presenterInvitation, setModalOpen }) => {
	const dispatch = useDispatch()
	
	const loadStatus = useSelector(state => state.presenterInvitation.rsvpStatus)

	// useEffect(() => {
	// 	if (loadStatus === 'Success') {
	// 		// dispatch(setEvent(newEvent))
	// 	}
	// }, [loadStatus, dispatch])

	const handleCloseClick = (e) => {
		setModalOpen(false);
	}

	// const reset = (e) => {
	// 	e.stopPropagation();
	// }

	const handleYesClick = (e) => {
		e.preventDefault()

		dispatch(updatePresenterInvitation({
			invitationId: invitationId,
			rsvp: true,
		}))
	}
	const handleNoClick = (e) => {
		e.preventDefault()
		
		dispatch(updatePresenterInvitation({
			invitationId: invitationId,
			rsvp: false,
		}))
	}

	const stopProp = (e) => { e.stopPropagation(); }

	const states = ['Idle', 'Success', 'Error']

	const YouGotItMessage = () => {
		return (
			<div>
				<h1>Success!</h1>
				<p>You got it! The event is yours!</p>
				<p>As we get it, the full information for the event will be here:</p>
				<a href={presenterInvitation.presenterInvitation.performer_url} className="button">
					Your presenter page for this event
				</a>
			</div>
		)
	}

	const YouDeclinedMessage = () => {
		return (
			<div>
				<h1>Roger that!</h1>
				<p>You declined this event.</p>
				<p>Thanks for letting us know! We'll keep sending you more invitations in the future.</p>
			</div>
		)
	}
	// const SuccessMessage = () => {
	// 	return (
	// 		<div>
	// 			<h1>Success!</h1>
	// 			<p>You got it! The event is yours!</p>
	// 			<p>As we get it, the full information for the event will be here:</p>
	// 			<a href='#' className="button">
	// 				Your presenter page for this event
	// 			</a>
	// 		</div>
	// 	)
	// }
	
	const ErrorMessage = () => {
		return (
			<div>
				<h1>Whoops!</h1>
				<p>Uh oh, something went wrong there.</p>
				<p>Shoot us an email!</p>
			</div>
		)
	}
	
	const RsvpPrompt = () => {
		return (
			<div>
				<h2 style={{marginTop: '0'}}>
					Your response
				</h2>
				<p>
					Are you available?
					<br />
					Do you want this event?
				</p>
				<br />
				
				<div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', maxWidth: '400px', margin: '0 auto'}}>
					<div>
						<a onClick={handleYesClick} href="#" className="button" style={{marginBottom: '0'}}>
							Yes!
						</a>
					</div>
					
					<div>
						<a onClick={handleNoClick} href="#" className="button" style={{marginBottom: '0'}}>
							Nope
						</a>
					</div>
				</div>
			</div>
		)
	}
	
	
	const content = { 
		Idle: (<RsvpPrompt />),
		// Idle: <StandardForm eventId={eventId} useAddressForm={useAddressForm} />,
		// Idle: <ErrorMessage />,
		Pending: (<div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Spinner /></div>),
		Success: (presenterInvitation.user_is_performer ? <YouGotItMessage /> : <YouDeclinedMessage /> ),
		Error: <ErrorMessage />,
	}[states.includes(loadStatus) ? loadStatus : 'Pending'] 

	return (
		<div className='modal-overlay' onClick={handleCloseClick}>
			<div className='modal' onClick={stopProp}>
				<div className='modal-inner-100'>
					<div className='modal-close-button' onClick={handleCloseClick}>&times;</div>

					{content}
		
				</div>
			</div>
		</div>
	)
}

const PresenterInvitationContent = ({ match }) => {
	// let stuff = useParams();
	// window.stuff = stuff;
	let { invitationId } = useParams();
	const dispatch = useDispatch()
	const presenterInvitation = useSelector(selectPresenterInvitation)
	const [modalOpen, setModalOpen] = useState(false)
	const states = ['Success', 'Error']

	console.log("presenterInvitation: ")
	console.log(presenterInvitation)
  
  const loadStatus = useSelector(state => state.presenterInvitation.fetchStatus)
  const error = useSelector(state => state.presenterInvitation.error)
	
	const handleResponseButtonClick = (e) => {
		e.preventDefault();
		if (modalOpen) {
			setModalOpen(false);
		} else {
			setModalOpen(true);
		}
	}

	useEffect(() => {
    if (loadStatus === 'Idle') {
      dispatch(fetchPresenterInvitation(invitationId))
    }
  }, [loadStatus, dispatch])

	// const userIsPresenter = presenterInvitation.user_is_performer
	
	const Invitation = () => {
		return (
			<div>
				<h1>👋 Hi {presenterInvitation.user.first_name}</h1>
				{ presenterInvitation.presenterInvitation.still_open ? 
						<p>We'd like to invite you to do an event for us!</p>
					: 
						<p>Sorry, someone already registered to presenter this event!</p>
				}
				
				<h2>
					Event info
				</h2>
				
				<dl style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr'}}>
					<LabeledValue label={'Date'} value={presenterInvitation.event.date} />
					<LabeledValue label={'Time'} value={presenterInvitation.event.time} />
					<LabeledValue label={'Duration'} value={presenterInvitation.event.duration} />
				</dl>

				<dl style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
				
					{ 
						!!presenterInvitation.event.archetype ? <LabeledValue label={'Type'} value={presenterInvitation.event.archetype} /> : (<div>&nbsp;</div>)
					}
					{ 
						( presenterInvitation.presenterInvitation || {} ).flat_fee ? 
							<LabeledValue label={'Rate'} value={<NumberFormat value={presenterInvitation.presenterInvitation.flat_fee} displayType={'text'} prefix={'$'} />} /> :
							(<div>&nbsp;</div>)
					}
				</dl>
				
				{ presenterInvitation.presenterInvitation.still_open ? 
						<StartResponseButton clickHandler={handleResponseButtonClick} /> 
					: 
						<p>We'll keep you in mind next time!</p>
				}
				
				
				{ modalOpen ? 
						<ResponseModal invitationId={invitationId} presenterInvitation={presenterInvitation} setModalOpen={setModalOpen} /> : 
						'' 
				}
			</div>
		)
	}
	
	const InvitationAccepted = () => {
		return (
			<div className='container' style={{maxWidth: '800px', margin: '4rem auto', fontSize: '21px', lineHeight: '1.4'}}>
				<h1>👋 Hi {presenterInvitation.user.first_name}</h1>
				<p>Thanks for registering for this event!</p>
				<p>All the info you need is at</p>
				<a href={presenterInvitation.presenterInvitation.performer_url} className="button">
					Your page for this event
				</a>
			</div>
		)
	}

	return {
 		Success: (
			( presenterInvitation.presenterInvitation || {} ).user_is_performer ? <InvitationAccepted /> : <Invitation />
		),
		Pending: (
			<div>
				<h1>Loading...</h1>
			</div>
		),
		Error: (
			<h1>Hmm, we didn't find an event invitation for you here 🤔</h1>
		)
	}[states.includes(loadStatus) ? loadStatus : 'Pending'] 
}

const PresenterInvitation = ({ match }) => {
	return (
		<div>
			<Header />
			<div className='container white shadow'>
				<PresenterInvitationContent match={match} />
			</div>
		</div>
	)
}

export default PresenterInvitation 